<template>
  <div class="forgot-container">
    <div class="forgot-card">
      <div class="image-container">
        <img 
          :src="currentImage" 
          alt="Recuperar contraseña" 
          class="forgot-image"
        >
      </div>
      
      <h2>¿Olvidaste tu contraseña?</h2>
      <p v-if="!success">Ingresa tu correo electrónico y te enviaremos un enlace</p>
      <p v-else>¡Revisa tu correo! Te hemos enviado un enlace para restablecer tu contraseña.</p>

      <div v-if="error" class="alert error">{{ errorMessage }}</div>

      <form v-if="!success" @submit.prevent="onSubmit">
        <div class="form-group">
          <input 
            type="email" 
            v-model="email" 
            placeholder="Correo electrónico" 
            required
            :disabled="loading"
          >
        </div>
        <button type="submit" :disabled="loading" class="btn-submit">
          <span v-if="loading" class="spinner"></span>
          {{ loading ? 'Enviando...' : 'Enviar enlace' }}
        </button>
      </form>

      <div class="text-center">
        <router-link to="/login" class="back-link">Volver al inicio de sesión</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '../../stores/auth'

const email = ref('')
const loading = ref(false)
const success = ref(false)
const error = ref(false)
const errorMessage = ref('')

const authStore = useAuthStore()

// Imagen dinámica según el estado
const currentImage = computed(() => {
  if (success.value) {
    return '/undraw_mail-sent_ujev.png'
  }
  return '/undraw_opened_47gd.png'
})

const onSubmit = async () => {
  if (!email.value) {
    error.value = true
    errorMessage.value = 'Ingresa tu correo electrónico'
    return
  }
  
  loading.value = true
  error.value = false
  errorMessage.value = ''

  const result = await authStore.forgotPassword(email.value)

  if (result.success) {
    success.value = true
    email.value = ''
  } else {
    error.value = true
    errorMessage.value = result.message
  }

  loading.value = false
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.forgot-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
}

.forgot-card {
  background: white;
  padding: 40px 30px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.image-container {
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
}

.forgot-image {
  width: 180px;
  height: auto;
  object-fit: contain;
}

h2 {
  color: #00144a;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

p {
  color: #666;
  font-size: 14px;
  margin-bottom: 25px;
  line-height: 1.5;
}

.alert {
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 20px;
  font-size: 14px;
}

.alert.error {
  background: #ffebee;
  color: #f12711;
  border-left: 4px solid #f12711;
}

.form-group {
  margin-bottom: 20px;
}

input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s;
  background: #f9f9f9;
}

input:focus {
  outline: none;
  border-color: #00144a;
  background: white;
  box-shadow: 0 0 0 3px rgba(0, 20, 74, 0.1);
}

input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: #00144a;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-submit:hover {
  background: #002a73;
  transform: translateY(-2px);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.text-center {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.back-link {
  color: #a50000;
  text-decoration: none;
  font-size: 14px;
}

.back-link:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .forgot-card {
    padding: 30px 20px;
  }
  
  .forgot-image {
    width: 140px;
  }
  
  h2 {
    font-size: 1.3rem;
  }
  
  input {
    padding: 12px 14px;
    font-size: 14px;
  }
  
  .btn-submit {
    padding: 12px;
  }
}
</style>